

























import Vue from 'vue';
import { IPost } from '../../../common/interfaces/searchbox.interface';

export default Vue.extend({
  name: `KnowledgeBase`,
  computed: {
    noDataFound(): boolean {
      return !this.loading && this.knowledgeBase.length === 0;
    },
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    knowledgeBase: {
      required: true,
      type: Array as () => IPost[],
    },
    loading: {
      required: true,
      type: Boolean,
    },
  },
});
